import CharacterDataBank from "../../../common/elements/CharacterDataBank";
import { Point2d } from "../../../common/geometry/Geom2d";
import TabletopElement from "./element/TabletopElement";
import TabletopGrid from "./grid/TabletopGrid";
import TabletopToken from "./token/TabletopToken";

export default class TabletopUniverse {
    private _backgroundElements: Array<TabletopElement>;
    private _tokens: Array<TabletopToken>;
    private _gridElement: TabletopGrid | null = null;
    private _unitLength: number = 32;

    private _characterBank: CharacterDataBank = new CharacterDataBank();

    constructor(args?: {
        elements?: Array<TabletopElement>;
        unitLength?: number;
    }) {
        this._backgroundElements = [];
        this._tokens = [];

        if (args?.unitLength != null) {
            this._unitLength = args.unitLength;
        }

        if (args?.elements != null) {
            args.elements.forEach((element) => this.addElement(element));
        }
    }

    public get elements() {
        return this._backgroundElements.concat(this._tokens);
    }

    public get backgroundElements() {
        return this._backgroundElements;
    }

    public get tokens() {
        return this._tokens;
    }

    public get gridElement() {
        return this._gridElement;
    }

    public get unitLength() {
        return this._unitLength;
    }

    public get defaultTokenSize() {
        return Math.floor(this._unitLength * 0.75);
    }

    public get characterBank(): CharacterDataBank {
        return this._characterBank;
    }

    public addElement(element: TabletopElement) {
        if (!this.elements.includes(element) && this._gridElement !== element) {
            if (element instanceof TabletopToken) {
                this._tokens.push(element);
            } else if (element instanceof TabletopGrid) {
                this._gridElement = element;
            } else {
                this._backgroundElements.push(element);
            }

            if (element.universe != null) {
                element.universe.removeElement(element);
            }

            element.universe = this;
        }
    }

    public removeElement(element: TabletopElement) {
        if (element instanceof TabletopToken) {
            this.removeToken(element);
        } else if (element instanceof TabletopGrid) {
            if (element === this._gridElement) {
                this._gridElement = null;
            }
        } else {
            this.removeBackgroundElement(element);
        }

        element.universe = null;
    }

    public removeToken(token: TabletopToken) {
        const index = this._tokens.findIndex((t) => t === token);

        if (index >= 0) {
            this._tokens.splice(index, 1);
        }
    }

    public removeBackgroundElement(element: TabletopElement) {
        const index = this._backgroundElements.findIndex((t) => t === element);

        if (index >= 0) {
            this._backgroundElements.splice(index, 1);
        }
    }

    public getTokensAtGridCoordinate(
        coordinate: Point2d,
    ): Array<TabletopToken> {
        if (this._gridElement == null) {
            return [];
        }

        return this._tokens.filter((token) => {
            const cellCoord =
                this._gridElement?.getCellCoordinatesFromUniversePoint(
                    token.position,
                );

            return (
                cellCoord?.x === coordinate.x && cellCoord?.y === coordinate.y
            );
        });
    }
}
